var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('router-link',{staticClass:"flex items-center w-full gap-2 px-4 py-2 mr-2 bg-white hover:shadow-md",attrs:{"props":_vm.report.props,"to":{ path: _vm.report.path }}},[_c('font-awesome-icon',{attrs:{"icon":['far', _vm.icon]}}),_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.report.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }